import React from "react";
import classNames from "classnames";
import withStyles from "elevate-ui/withStyles";

type Props = {
  children: any,
};

const AgentListings = ({ children, classes, className }: Props) => {
  return <div className={classNames(classes.root, className)}>{children}</div>;
};

export default withStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "1200px",
    padding: theme.spacing.unit * 0.5,
    margin: "96px auto",
  },
}))(AgentListings);
